import { styled } from '@acko-tech/building-blocks.ui.common';

export const Container = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 10px;
    margin-top: 30px;
`;

export const SelectorContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const Selector = styled.div`
    padding: 8px 12px;
    display: flex;
    flex-direction: row;
    align-items: center;
    border: ${(props) =>
        props.selected ? '1px solid #5B5675' : '1px solid #E7E7F0'};
    border-radius: 6px;
    cursor: pointer;
    margin-right: 8px;
`;

export const SelectorText = styled.div`
    font-size: 14px;
    font-weight: 500;
    color: #040222;
    margin-right: 10px;
    font-weight: ${(props) => (props.selected ? '600' : '500')};
`;

export const Tile = styled.div`
    padding: 10px 16px;
    font-size: 16px;

    background-color: ${(props) =>
        props.selected ? '#0fa457' : 'transparent'};
    font-weight: ${(props) => (props.selected ? '600' : '400')};
    color: ${(props) => (props.selected ? 'white' : '#040222')};

    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    box-sizing: border-box;
    text-align: center;
    width: 65px;
`;
